import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GroupBehavior } from '../types/layoutBuilder.types'

export type BehaviorObject = Partial<Record<GroupBehavior, string[]>>

export interface GroupBehaviorState {
  behaviors: Record<string, BehaviorObject>
}

const initialState: GroupBehaviorState = {
  behaviors: {},
}

const groupBehaviorSlice = createSlice({
  name: 'groupBehavior',
  initialState,
  reducers: {
    setGroupBehavior(
      state,
      action: PayloadAction<{ key: string; behaviorObj: BehaviorObject }>
    ) {
      state.behaviors[action.payload.key] = action.payload.behaviorObj
    },
    clearGroupBehavior(state, action: PayloadAction<{ key: string }>) {
      delete state.behaviors[action.payload.key]
    },
  },
})

export const { setGroupBehavior, clearGroupBehavior } =
  groupBehaviorSlice.actions

export default groupBehaviorSlice.reducer

/**
 * Merges all provider behavior objects into a single BehaviorObject.
 * Use this in useAppSelector instead of accessing state.groupBehavior.behaviors
 * directly.
 */
export const selectMergedBehaviorObj = (state: {
  groupBehavior: GroupBehaviorState
}): BehaviorObject =>
  Object.values(state.groupBehavior.behaviors).reduce<BehaviorObject>(
    (merged, obj) => {
      ;(Object.keys(obj) as GroupBehavior[]).forEach((behavior) => {
        merged[behavior] = [
          ...(merged[behavior] ?? []),
          ...(obj[behavior] ?? []),
        ]
      })
      return merged
    },
    {}
  )
